import { render } from "./AccountsAccess.vue?vue&type=template&id=b42b2cea&scoped=true"
import script from "./AccountsAccess.vue?vue&type=script&lang=js"
export * from "./AccountsAccess.vue?vue&type=script&lang=js"

import "./AccountsAccess.vue?vue&type=style&index=0&id=b42b2cea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42b2cea"]])

export default __exports__